import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/SliderInput/RangeSliderInput.tsx
import React, { useCallback, useEffect, useState } from "react";
var RangeSliderInput = _a => {
  var _b = _a,
    {
      id,
      name,
      value,
      min,
      max,
      step,
      onChange,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "value", "min", "max", "step", "onChange", "className"]);
  const [minValue, setMinValue] = useState(value ? value[0] : min);
  const [maxValue, setMaxValue] = useState(value ? value[1] : max);
  const minPosition = (minValue - min) / (max - min) * 100;
  const maxPosition = (maxValue - min) / (max - min) * 100;
  const handleMinChange = useCallback(event => {
    event.preventDefault();
    const newMinVal = Math.min(+event.target.value, maxValue - step);
    if (typeof value === "undefined") {
      setMinValue(newMinVal);
    }
    onChange == null ? void 0 : onChange([newMinVal, maxValue]);
  }, [maxValue, step, value, onChange]);
  const handleMaxChange = useCallback(event => {
    event.preventDefault();
    const newMaxVal = Math.max(+event.target.value, minValue + step);
    if (typeof value === "undefined") {
      setMaxValue(newMaxVal);
    }
    onChange == null ? void 0 : onChange([minValue, newMaxVal]);
  }, [minValue, step, value, onChange]);
  useEffect(() => {
    if (typeof value !== "undefined") {
      setMinValue(value[0]);
      setMaxValue(value[1]);
    }
  }, [value]);
  return /* @__PURE__ */React.createElement("div", {
    className
  }, /* @__PURE__ */React.createElement("div", {
    className: "pd-relative pd-z-0 pd-h-5"
  }, /* @__PURE__ */React.createElement("input", __spreadValues({
    id: "".concat(id, "-min"),
    name: "".concat(name, "-min"),
    type: "range",
    min,
    max,
    step,
    value: minValue,
    onChange: handleMinChange,
    className: "pd-slider-input__input pd-slider-input__input--min pd-pointer-events-none pd-absolute pd-inset-x-[-0.625rem] pd-z-[3] pd-h-5 pd-appearance-none pd-opacity-0"
  }, rest)), /* @__PURE__ */React.createElement("input", __spreadValues({
    id: "".concat(id, "-max"),
    name: "".concat(name, "-max"),
    type: "range",
    min,
    max,
    step,
    value: maxValue,
    onChange: handleMaxChange,
    className: "pd-slider-input__input pd-slider-input__input--max pd-pointer-events-none pd-absolute pd-inset-x-[-0.625rem] pd-z-[3] pd-h-5 pd-appearance-none pd-opacity-0"
  }, rest)), /* @__PURE__ */React.createElement("div", {
    style: {
      left: "".concat(minPosition, "%")
    },
    className: "pd-slider-input__thumb--min pd-absolute pd-z-[2] pd-ml-[-0.625rem] pd-size-5 pd-rounded-full pd-border-2 pd-border-primary-600 pd-bg-white"
  }), /* @__PURE__ */React.createElement("div", {
    className: "pd-slider-input__track pd-absolute pd-inset-x-0 pd-top-[0.375rem] pd-h-2 pd-rounded-full pd-bg-dim-200"
  }), /* @__PURE__ */React.createElement("div", {
    className: "pd-absolute pd-top-[0.375rem] pd-h-2 pd-rounded-full pd-bg-primary-500",
    style: {
      left: "".concat(minPosition, "%"),
      right: "".concat(100 - maxPosition, "%")
    }
  }), /* @__PURE__ */React.createElement("div", {
    style: {
      left: "".concat(maxPosition, "%")
    },
    className: "pd-slider-input__thumb--max pd-absolute pd-z-[2] pd-ml-[-0.625rem] pd-size-5 pd-rounded-full pd-border-2 pd-border-primary-600 pd-bg-white"
  })));
};
var RangeSliderInput_default = RangeSliderInput;
export { RangeSliderInput_default };